export default __webpack_public_path__ + "static/media/sensotrend_signin_signup.bf45066d.png";